import { useCallback, useEffect } from 'react';

import { useMap } from '@domain/map/MapContext';
import { useExplore } from '../context/ExploreContext';

/**
 * Custom hook that updates the explore URL based on user interactions.
 * It listens for dragend and zoomend events on the map and saves the updated parameters in the URL.
 */
export function useUpdateExploreUrlFromUserInteraction(): void {
  const { map } = useMap();
  const { saveParamsInUrl } = useExplore();

  const onUserInteractionEnd = useCallback(() => {
    if (map) {
      const { lat, lng } = map.getCenter();
      saveParamsInUrl(
        {
          latitude: lat,
          longitude: lng,
          zoom: map.getZoom(),
        },
        { replace: true },
      );
    }
  }, [map, saveParamsInUrl]);

  useEffect(() => {
    if (map) {
      map.on('dragend', onUserInteractionEnd);
      // zoomend will also be fired on non-user events like setZoom/flyTo etc.
      // So, we cant use it for now as it will cause inconsistent urls since next/navigation router cant be awaited
      // map.on('zoomend', onUserInteractionEnd);
    }

    return () => {
      if (map) {
        map.off('dragend', onUserInteractionEnd);
        // map.off('zoomend', onUserInteractionEnd);
      }
    };
  }, [map, onUserInteractionEnd]);
}
